// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"549":"47b55714","583":"10bfbc90","599":"38410897","665":"4ec8bc96","681":"c21ede88","721":"394b5c74"}[chunkId] + ".js";
};